export default __webpack_public_path__ + "images/0xa25b25548b4c98b0c7d3d27dca5d5ca743d68b7f.png";